import { useMemo } from 'react';
import { useSmartListsQuery } from 'shared/hooks/queries/use-smart-lists-query';
import { useUser } from 'shared/hooks/use-user';

type UseSmartListsOptions = {
  excludeFrozen?: boolean;
};

export const useSmartLists = (options?: UseSmartListsOptions) => {
  const user = useUser();
  const { data } = useSmartListsQuery(user?.uid);

  return useMemo(() => {
    const smartLists = data ?? [];
    if (options?.excludeFrozen) {
      return smartLists.filter((smartList) => !smartList.frozenAt);
    }
    return smartLists;
  }, [data, options?.excludeFrozen]);
};
